import { localePath } from "../i18n";
import type { Locale } from "../i18n/types";
import type { Messages } from "../i18n/types";

const BASE_URL = "https://ip.caylet.com";

function setMeta(selector: string, value: string): void {
  document.querySelector<HTMLMetaElement>(selector)?.setAttribute("content", value);
}

export function updateDocumentMetadata(locale: Locale, copy: Messages): void {
  const url = `${BASE_URL}${localePath(locale)}`;
  document.documentElement.lang = locale;
  document.title = copy.seo.title;
  setMeta('meta[name="description"]', copy.seo.description);
  setMeta('meta[property="og:title"]', copy.seo.title);
  setMeta('meta[property="og:description"]', copy.seo.description);
  setMeta('meta[property="og:url"]', url);
  setMeta('meta[name="twitter:title"]', copy.seo.title);
  setMeta('meta[name="twitter:description"]', copy.seo.description);
  document.querySelector<HTMLLinkElement>('link[rel="canonical"]')?.setAttribute("href", url);
  const structuredData = document.querySelector<HTMLScriptElement>('script[type="application/ld+json"]');
  if (structuredData) {
    structuredData.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebApplication",
          name: copy.brand.tool,
          url,
          applicationCategory: "UtilitiesApplication",
          operatingSystem: "Any",
          description: copy.seo.description
        },
        {
          "@type": "FAQPage",
          mainEntity: copy.faq.items.map((item) => ({
            "@type": "Question",
            name: item.q,
            acceptedAnswer: { "@type": "Answer", text: item.a }
          }))
        }
      ]
    });
  }
}
